const type = 'UPDATE_PAYMENT_SPLIT_INVOICE';

const updatePaymentSplitInvoice = (data) => ({
  data,
  type,
});

export default updatePaymentSplitInvoice;
